import React from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { GlobalStyles } from "./styles/GlobalStyles";
import Home from "./pages/Home";
import AppShell from "./admin/layouts/AppShell";
import AdminPlaceholderPage from "./admin/pages/AdminPlaceholderPage";
import DashboardPage from "./admin/pages/DashboardPage";
import DocsPage from "./admin/pages/DocsPage";
import IssuesPage from "./admin/pages/IssuesPage";
import LoginPage from "./admin/pages/LoginPage";
import { isAdminAuthenticated } from "./admin/utils/auth";
import { NeuralChatRoutes } from "./neuralchat/NeuralChatRoutes";

const PrivateAdminRoute: React.FC = () => {
  if (!isAdminAuthenticated()) {
    return <Navigate to="/admin/login" replace />;
  }

  return <AppShell />;
};

const App = () => {
  return (
    <Router>
      <GlobalStyles />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/neuralchat/*" element={<NeuralChatRoutes />} />
        <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
        <Route path="/admin/login" element={<LoginPage />} />
        <Route path="/admin/*" element={<PrivateAdminRoute />}>
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="issues" element={<IssuesPage />} />
          <Route
            path="billing"
            element={
              <AdminPlaceholderPage
                title="Billing"
                description="LLM 모델별 토큰 사용량, 일일 추이, 예상 청구 금액을 추적하는 과금 페이지입니다."
              />
            }
          />
          <Route path="docs" element={<DocsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
